import { baseColorsDark, baseColorsLight } from '../../base/tokens/colors'

// should match base values until we have a need for different values
export const journeyUiColorsLight = baseColorsLight
export const journeyUiColorsDark = baseColorsDark
